export const SHOW_TOUR_GUIDE_TOOLTIP = 'tourGuide/SHOW_TOUR_GUIDE_TOOLTIP';
export const SWITCH_SINGLE_TOOLTIP_MODE =
  'tourGuide/SWITCH_SINGLE_TOOLTIP_MODE';
